import XLSX from 'xlsx-js-style'

// Barcha Excel eksportlari uchun yagona stil:
// - sarlavha (header) qatori: qalin, kulrang fon, qora ramka, markazda
// - ma'lumot kataklari: yupqa qora ramka
// - sonlar: ming ajratuvchi + 2 kasr (#,##0.00)
// - manfiy sonlar: qizil rang
// Stil aoa_to_sheet bilan yaratilgan worksheet ustida ishlaydi (qiymatlar o'zgarmaydi).

const THIN_BORDER = {
	top: { style: 'thin', color: { rgb: '000000' } },
	bottom: { style: 'thin', color: { rgb: '000000' } },
	left: { style: 'thin', color: { rgb: '000000' } },
	right: { style: 'thin', color: { rgb: '000000' } },
}

const HEADER_BORDER = {
	top: { style: 'medium', color: { rgb: '000000' } },
	bottom: { style: 'medium', color: { rgb: '000000' } },
	left: { style: 'medium', color: { rgb: '000000' } },
	right: { style: 'medium', color: { rgb: '000000' } },
}

// Butun sonlarga ortiqcha ".00" qo'shilmaydi (1 -> "1", 8888 -> "8,888"),
// haqiqiy kasrli sonlar esa 2 xonagacha ko'rsatiladi (8888.5 -> "8,888.50").
const INT_FORMAT = '#,##0'
const DECIMAL_FORMAT = '#,##0.00'
// Qayta importga mo'ljallangan eksportlar uchun probelsiz format: minglik ajratgichsiz.
const PLAIN_INT_FORMAT = '0'
const PLAIN_DECIMAL_FORMAT = '0.00'

function numberFormatFor(value, plainNumbers) {
	const isInt = Number.isInteger(Number(value))
	if (plainNumbers) return isInt ? PLAIN_INT_FORMAT : PLAIN_DECIMAL_FORMAT
	return isInt ? INT_FORMAT : DECIMAL_FORMAT
}

function headerCellStyle() {
	return {
		font: { bold: true, color: { rgb: '000000' } },
		fill: { patternType: 'solid', fgColor: { rgb: 'D9D9D9' } },
		alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
		border: HEADER_BORDER,
	}
}

function dataCellStyle(isNumber, isNegative, numFmt) {
	const style = {
		font: { color: { rgb: isNegative ? 'FF0000' : '000000' } },
		border: THIN_BORDER,
		alignment: { vertical: 'center', wrapText: true, horizontal: isNumber ? 'right' : 'left' },
	}
	if (isNumber) style.numFmt = numFmt
	return style
}

/**
 * aoa_to_sheet orqali yaratilgan worksheet'ga yagona hisobot stilini qo'llaydi.
 * @param {object} ws - XLSX worksheet
 * @param {object} [options]
 * @param {number} [options.headerRows=1] - sarlavha qatorlari soni
 * @param {boolean} [options.autoWidth=true] - ustun kengligini avtomatik moslash
 * @returns {object} worksheet
 */
export function styleExcelSheet(ws, options = {}) {
	const headerRows = options.headerRows ?? 1
	const autoWidth = options.autoWidth ?? true
	const plainNumbers = options.plainNumbers ?? false
	if (!ws || !ws['!ref']) return ws

	const range = XLSX.utils.decode_range(ws['!ref'])

	for (let R = range.s.r; R <= range.e.r; R++) {
		for (let C = range.s.c; C <= range.e.c; C++) {
			const addr = XLSX.utils.encode_cell({ r: R, c: C })
			let cell = ws[addr]
			if (!cell) {
				cell = { t: 's', v: '' }
				ws[addr] = cell
			}

			if (R < headerRows) {
				cell.s = headerCellStyle()
				continue
			}

			const isNumber = cell.t === 'n' || typeof cell.v === 'number'
			const isNegative = isNumber && Number(cell.v) < 0
			const numFmt = isNumber ? numberFormatFor(cell.v, plainNumbers) : null
			cell.s = dataCellStyle(isNumber, isNegative, numFmt)
			if (isNumber) cell.z = numFmt
		}
	}

	if (autoWidth && !ws['!cols']) {
		const cols = []
		for (let C = range.s.c; C <= range.e.c; C++) {
			let maxLen = 10
			for (let R = range.s.r; R <= range.e.r; R++) {
				const addr = XLSX.utils.encode_cell({ r: R, c: C })
				const cell = ws[addr]
				if (cell && cell.v != null) {
					const len = String(cell.v).length
					if (len > maxLen) maxLen = len
				}
			}
			cols.push({ wch: Math.min(maxLen + 2, 45) })
		}
		ws['!cols'] = cols
	}

	return ws
}

export default styleExcelSheet
